import { createFileRoute, redirect } from '@tanstack/react-router';

// s264 — the cross-campaign followups page was retired in favour of
// the rail-teaser + triage-drawer pattern on /home. This route stays
// alive as a bookmark-compat redirector so old links (founder
// bookmarks, notification deep-links, the /followups top-level
// redirector) land on the new surface.
export const Route = createFileRoute('/brand/$slug/followups')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/brand/$slug/home',
      params: { slug: params.slug },
      search: { triage: 'followups' as const },
    });
  },
  component: () => null,
});
